

/**
 * The locale code of the default language to display the site in.
 * @type { string }
 */
export const DEFAULT_LOCALE_CODE = 'en-US';
export const DEFAULT_LOCALE_NAME = 'English (United States)';
 
